import type { JSX } from "preact";

export function NavHr(): JSX.Element {
    return <li className="nav-hr" />;
}
